import { errorAction, successfulAction } from '@shared/actions';
import { STATUS_CODE } from '@shared/constants';
import getProductsOptionsReplace from '@services/cart/getProductsOptionsReplace';

import { PRODUCT_OPTIONS_REPLACE as type } from '@core/reducers/cart/actionTypes';

const errorCode = STATUS_CODE.INTERNAL_ERROR;

const fetchProductsOptionsReplace = shopId => async (dispatch, _, axios) => {
  try {
    if (shopId) {
      const { success, data } = await getProductsOptionsReplace({
        axios,
        vendor: shopId,
      });
      if (success) {
        dispatch(
          successfulAction({
            type,
            payload: data.data,
          }),
        );
        return data.data;
      }
      return false;
    }
  } catch (error) {
    dispatch(
      errorAction({
        type,
        error,
        errorCode,
      }),
    );
  }
  return false;
};

export default fetchProductsOptionsReplace;
